import React from 'react'
import { formatPhoneNumber } from 'utils'
import { IOffice } from './IOffice'

interface IOfficeInfoProps {
  office: IOffice
}

const OfficeInfo: React.FC<IOfficeInfoProps> = ({ office }) => {
  return (
    <div>
      {office.address}
      <br />
      {office.work_time && (
        <>
          время работы: <br />
          <div className='px-4' dangerouslySetInnerHTML={{ __html: office.work_time }} />
        </>
      )}
      {office.phone_number && (
        <>
          <a href={'tel:+7' + office.phone_number}>
            тел. {formatPhoneNumber(office.phone_number)}
          </a>
          <br />
        </>
      )}
      <div>
        Способы оплаты:
        {office.payment_types.map((type) => (
          <div key={type.payment_type_id} className='px-4'>
            {type.payment_type}
          </div>
        ))}
      </div>
    </div>
  )
}
export default OfficeInfo
